import $http from './http'
import config from './config'
export default {
    name: 'base',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    getZoneList(data) {
        return $http.post(this.getUrl(`/ZoneInfo/List`), data);
    },
    getZoneInfo(ZoneID) {
        return $http.get(this.getUrl(`/ZoneInfo/Details/${ZoneID}`));
    },
    saveZoneInfo(data) {
        return $http.post(this.getUrl(`/ZoneInfo/Save`), data);
    },
    deleteZoneInfo(ZoneID) {
        return $http.get(this.getUrl(`/ZoneInfo/Delete/${ZoneID}`));
    },
    getContinentInfoList(data){
        return $http.post(this.getUrl('/ContinentInfo/List'),data);
    },
    getContinentInfo(id){
        return $http.get(this.getUrl('/ContinentInfo/Details/'+id));
    },
    saveContinentInfo(data){
        return $http.post(this.getUrl('/ContinentInfo/Save'),data);
    },
    getAreaInfoList(data){
        return $http.post(this.getUrl('/AreaInfo/List'),data);
    },
    getAreaInfo(id){
        return $http.get(this.getUrl('/AreaInfo/Details'+id));
    },
    saveAreaInfo(data){
        return $http.post(this.getUrl('/AreaInfo/Save'),data);
    },
    getCountryInfoList(data){
        return $http.post(this.getUrl('/CountryInfo/List'),data)
    },
    getCountryInfo(id){
        return $http.get(this.getUrl('/CountryInfo/Details/'+id))
    },
    saveCountryInfo(data){
        return $http.post(this.getUrl("/CountryInfo/Save"),data)
    },
    getProvinceInfoList(data){
        return $http.post(this.getUrl('/ProvinceInfo/List'),data)
    },
    getProvinceInfo(id){
        return $http.get(this.getUrl('/ProvinceInfo/Details/'+id))
    },
    saveProvinceInfo(data){
        return $http.post(this.getUrl('ProvinceInfo/Save'),data)
    },
    getCityInfoList(data){
        return $http.post(this.getUrl('/CityInfo/List'),data)
    },
    getCityInfo(id){
        return $http.get(this.getUrl('/CityInfo/List/'+id))
    },
    saveCityInfo(data){
        return $http.post(this.getUrl('/CityInfo/Save'),data)
    },
    getDistrictInfoList(data){
        return $http.post(this.getUrl('/DistrictInfo/List'),data);
    },
    saveDistrictInfo(data){
        return $http.post(this.getUrl('/DistrictInfo/Save'),data)
    },
    getAirportInfoList(data){
        return $http.post(this.getUrl('/AirportInfo/List'),data);
    },
    saveAirportInfo(data){
        return $http.post(this.getUrl('/AirportInfo/Save'),data);
    },
    getScenicInfoList(data){
        return $http.post(this.getUrl('/ScenicInfo/List'),data);
    },
    saveScenicInfo(data){
        return $http.post(this.getUrl('/ScenicInfo/Save'),data);
    },
    getStationInfoList(data){
        return $http.post(this.getUrl('/StationInfo/List'),data);
    },
    saveStationInfo(data){
        return $http.post(this.getUrl('/StationInfo/Save'),data);
    },
    getAirwayInfoList(data){
        return $http.post(this.getUrl('/AirwayInfo/List'),data);
    },
    saveAirwayInfo(data){
        return $http.post(this.getUrl('/AirwayInfo/Save'),data);
    },
    getBerthInfoList(data){
        return $http.post(this.getUrl('/BerthInfo/List'),data);
    },
    saveBerthInfo(data){
        return $http.post(this.getUrl('/BerthInfo/Save'),data);
    },
    delBerthInfo(id){
        return $http.post(this.getUrl('/BerthInfo/Delete/'+id));
    },
    getExtraInfoList(data){
        return $http.post(this.getUrl('/ExtraInfo/List'),data);
    },
    saveExtraInfo(data){
        return $http.post(this.getUrl('/ExtraInfo/Save'),data)
    },
    deleteExtraInfo(id){
        return $http.get(this.getUrl('/ExtraInfo/Delete?id='+id))
    },
    // getCountrys(id) {
    //     return $http.get(this.getUrl(`/CountryInfo/Countrys/${id}`));
    // },
    
    // getCitys(countryID) {
    //     return $http.get(this.getUrl(`/GetBaseInfo/CountryCitys/${countryID}`));
    // },

    // getPosition() {
    //     return $http.post(this.getUrl('/TourCity/Position'));
    // },

    // getZoneInfoByCity(id) {
    //     return $http.post(this.getUrl(`/ZoneInfo/GetZoneBycityID/${id}`));
    // },
    // getareas(keyword) {
    //     return $http.post(this.getUrl(`/ZoneInfo/GetZones/${keyword}`));
    // },
    // getzoneareas(data) {
    //     return $http.post(this.getUrl('/ZoneInfo/GetZonesArea'), data);
    // },
    // getimgs(data) {
    //     return $http.post(this.getUrl('/ZoneInfo/SerachImgs'), data);
    // },
    // getSpotname(keyword) {
    //     return $http.post(this.getUrl(`/TourCity/IdtoSpot/${keyword}`));
    // },
    // ZoneSpots(id) {
    //     return $http.post(this.getUrl(`/TourServers/ZoneSpots/${id}`));
    // },
    // CitySports(id) {
    //     return $http.post(this.getUrl(`/TourServers/CitySports/${id}`));
    // },
    // CitySportName(id) {
    //     return $http.post(this.getUrl(`/TourServers/CitySportName/${id}`));
    // },
    // Airways() {
    //     return $http.post(this.getUrl(`/Airway/Airways`));
    // },
    // Cabins(id) {
    //     return $http.post(this.getUrl(`/Berth/Cabins/${id}`));
    // },
    // getAttrArea(data) {
    //     return $http.post(this.getUrl('/CountryInfo/AttrArea'), data);
    // },
    // getdistinct(data) {
    //     return $http.post(this.getUrl('/DistrictInfo/GetDist'), data);
    // },
    // GetCitys(id) {
    //     return $http.post(this.getUrl(`/TourServers/GetCityInfo/${id}`));
    // },
    // GetCityInfo(id) {
    //     return $http.post(this.getUrl(`/GetBaseInfo/GetCityInfo/${id}`));
    // },
    // getZoneInfo(data) {
    //     return $http.post(this.getUrl('/ZoneInfo/GetZoneInfo'), data);
    // },
    // getTrainList(data) {
    //     return $http.post(this.getUrl(`/TourServers/LoadCityInfo`), data);
    // },
    // getContinentInfo() {
    //     return $http.post(this.getUrl(`/ContinentInfo/List`));
    // },
    // CounryQuery(id) {
    //     return $http.post(this.getUrl(`/TourServers/CounryQuery/${id}`));
    // },

    gettripcom() {
        var reg = /^www./g;
        let hostname = window.location.hostname;
        if (!reg.test(hostname)) {
            hostname = 'www.lchtrip.com';
        }
        return $http.get(this.getUrl(`/static/${hostname.replace(/\./g,'')}/${hostname.replace(/\./g,'')}.json`).replace('/api/base', ''), );
    },
    // 列表 
    getMapInfoList(data){
        return $http.post(this.getUrl('/mapInfo/List'),data);
    },
    // 详情 
    DetailsMapInfo(id){
        return $http.get(this.getUrl('/mapInfo/Details?id='+id))
    },
    // 保存 
    saveMapInfo(data) {
        return $http.post(this.getUrl('/mapInfo/Save'), data);
    },
    // 删除 
    deleteMapInfo(id){
        return $http.post(this.getUrl('/mapinfo/delete?id='+id));
    },
}



// WEBPACK FOOTER //
// ./src/apis/baseApis.js